<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto">
      <div class="time">活动时间：11.1-11.11</div>
      <div class="activity-nav" :class="{fixed: isFixed}">
        <a :class="{cur: navIndex === index}" v-for="(item, index) in navList" :key="index" @click="changeNav(index)">{{item}}</a>
      </div>
      <div class="img-box" id="1">
        <img src="../../assets/images/activity/activity202111/title1.png" alt="" class="title">
      </div>
      <div class="mod mod1">
        <div class="mod-con">
          <div class="top-con">
            <p>大智慧策略投资终端<span>1年</span></p>
            <em>+</em>
            <p>优选大师财富版<span>1年</span></p>
          </div>
          <p>高级软件专家一对一软件讲解服务1年</p>
          <p>大智慧月度特刊1年</p>
          <p>AI资金组合模型1年<a @click="changeNav(4)">点击了解AI资金眼</a></p>
          <div class="buy-box">
            <span @click="goUrl(4024)">立即购买</span>
            <em>￥54800/年</em>
          </div>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/images/activity/activity202111/title2.png" alt="" class="title">
      </div>
      <div class="mod mod2">
        <div class="mod-con">
          <img src="../../assets/images/activity/activity202111/title2-1.png" alt="">
          <div class="item">
            <p>购买《大智慧365》年卡赠送1年期限</p>
            <span @click="goUrl(116, 24)">立即购买<em>￥998/1年+送一年</em></span>
          </div>
          <div class="item">
            <p>购买《大智慧专业版》年卡赠送1年期限</p>
            <span @click="goUrl(73, 24)">立即购买<em>￥2680/1年+送一年</em></span>
          </div>
          <p>温馨提示：双年卡、季卡、月卡均不参与买1送1活动。</p>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/images/activity/activity202111/title3.png" alt="" class="title">
      </div>
      <div class="mod mod2">
        <div class="mod-con">
          <div class="item">
            <p>6折购《大智慧365》</p>
            <span @click="goUrl(116)" class="spe">立即购买</span>
          </div>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/images/activity/activity202111/title4.png" alt="" class="title">
      </div>
      <div class="mod mod2">
        <div class="mod-con">
          <div class="item">
            <p class="spe">购《优选大师财富版》年卡<br><em>送</em>《大智慧财富版》年卡</p>
            <span @click="goUrl(197)" class="spe spe2">立即购买</span>
          </div>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/images/activity/activity202111/title5.png" alt="" class="title">
      </div>
      <div class="mod mod2 mod3">
        <div class="mod-con">
          <div class="item">
            <img src="../../assets/images/activity/activity202111/icon1.png" alt="">
            <p><em>AI资金眼：</em>高端指标双结合，监测大智慧DDE决策资金+AI资金线资金强度，筛选出资金异动量价齐升个股，双重智能选股策略，帮助投资者抓住投资机会。</p>
          </div>
          <div class="item">
            <img src="../../assets/images/activity/activity202111/icon2.png" alt="">
            <p><em>两大资金指标：</em>DDE决策(限定资金净流入额)+AI（资金线控近期主力资金活跃度异动情况）</p>
          </div>
          <div class="item">
            <img src="../../assets/images/activity/activity202111/icon3.png" alt="">
            <p><em>三重定义：</em>定义流入额、定义AI活跃度大小、定义选股周期及个股市值；</p>
          </div>
          <div class="item">
            <img src="../../assets/images/activity/activity202111/icon4.png" alt="">
            <p><em>四轮排除：</em>排除短期涨幅过高的个股、排除整体走势处于弱势的个股、排除近期出现急涨急跌的个股、排除放量太大的个股</p>
          </div>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/images/activity/activity202111/title6.png" alt="" class="title">
      </div>
      <div class="mod mod2">
        <div class="mod-con">
          <div class="item banner-wrap">
            <el-carousel height="600px">
              <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img :src="item" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <p class="time2">活动日期：<em>11月1日-11月11日</em></p>
      <div class="img-box">
        <img src="../../assets/images/activity/activity202111/title7.png" alt="" class="title">
      </div>
      <div class="mod mod2">
        <div class="mod-con">
          <div class="item">
            <p>大智慧策略投资终端，老用户购买优选大师财富版不赠送大智慧财富版年卡，大智慧365及大智慧专业版双年卡、季卡、月卡均不参与买一送一活动</p>
          </div>
        </div>
      </div>
      <p class="tips">投资有风险，入市需谨慎</p>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',
      navIndex: 0,
      navList: ['买2得5', '买1送1', '矩惠折扣', '优选大师'],
      isFixed: false,
      bannerList: [
        require("@/assets/images/activity/activity202111/img1.png"),
        require("@/assets/images/activity/activity202111/img2.png"),
        require("@/assets/images/activity/activity202111/img3.png"),
        require("@/assets/images/activity/activity202111/img4.png"),
        require("@/assets/images/activity/activity202111/img5.png")
      ]
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {
    let navTop = document.querySelector(".activity-nav").offsetTop
    window.onscroll = () => {
      let scrH = document.body.scrollTop || document.documentElement.scrollTop
      if (scrH >= navTop) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    }
  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      if (this.token && key !== 4024) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    },
    changeNav (i) {
      this.navIndex = i
      let titles = document.querySelectorAll('.img-box')
      if (!this.isFixed) {
        window.scrollTo(0, titles[i].offsetTop - 60)
      } else {
        window.scrollTo(0, titles[i].offsetTop)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background: url(../../assets/images/activity/activity202111/bg1.jpg) no-repeat center 100px,
  url(../../assets/images/activity/activity202111/bg2.jpg) no-repeat center 1100px,
  url(../../assets/images/activity/activity202111/bg3.jpg) no-repeat center 2100px,
  url(../../assets/images/activity/activity202111/bg4.jpg) no-repeat center 3100px,
  url(../../assets/images/activity/activity202111/bg5.jpg) no-repeat center 4100px,
  url(../../assets/images/activity/activity202111/bg6.jpg) no-repeat center 5100px,
  url(../../assets/images/activity/activity202111/bg7.jpg) no-repeat center 6100px #931015;
  .auto{
    width: 1200px;
    margin: 0 auto;
  }
  .time{
    width: 206px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #e0495d;
    color: #fff;
    font-size: 18px;
    margin: 556px auto 165px;
    border-radius: 20px;
  }
  .activity-nav{
    background: #d92f3d;
    height: 60px;
    line-height: 60px;
    border-radius: 10px;
    overflow: hidden;
    &.fixed{
      position: fixed;
      left: 50%;
      margin-left: -600px;
      top: 0;
      z-index: 99;
    }
    a{
      font-size: 30px;
      color: #ffccd4;
      width: 300px;
      float: left;
      text-align: center;
      height: 100%;
      &.cur{
        background: linear-gradient(to bottom, #f3647b, #dc4356);
        border-radius: 10px;
        border-bottom: 2px solid #fdf0a8;
        color: #fdf0a8;
        font-weight: bolder;
      }
    }
  }
  .img-box{
    padding-top: 100px;
  }
  .title{
    display: block;
    margin: 0px auto 40px;
  }
  .mod{
    background: #7d0c0c;
    border-radius: 20px;
    border: 2px solid #e9d6ad;
    padding: 15px;
    .mod-con{
      background: #fff;
      border-radius: 20px;
      padding: 40px 60px;
    }
  }
  .mod1{
    .mod-con{
      font-size: 30px;
      color: #d47b02;
      position: relative;
      >p{
        width: 675px;
        height: 70px;
        line-height: 70px;
        padding-left: 20px;
        margin-top: 38px;
        background: #fff2d9;
        border-radius: 10px;
        font-weight: bold;
        a{
          float: right;
          color: #0079e9;
          padding-right: 20px;
          &:after{
            content: '';
            display: inline-block;
            background: url(../../assets/images/activity/activity202111/arrow.png) no-repeat;
            width: 17px;
            height: 15px;
            vertical-align: middle;
            margin: -1px 0 0 10px;
          }
        }
      }
      .top-con{
        overflow: hidden;
        p{
          background: #fff2d9;
          border-radius: 10px;
          float: left;
          text-align: center;
          height: 140px;
          padding-top: 20px;
          font-weight: bold;
          &:nth-of-type(1) {
            width: 335px;
          }
          &:nth-of-type(2) {
            width: 270px;
          }
          span{
            display: block;
            margin-top: 20px;
          }
        }
        em{
          float: left;
          font-size: 56px;
          margin: 45px 15px 0;
        }
      }
      .buy-box{
        position: absolute;
        top: 200px;
        right: 50px;
        text-align: center;
        span{
          font-size: 48px;
          color: #fff;
          display: block;
          width: 303px;
          height: 109px;
          text-align: center;
          line-height: 109px;
          background: linear-gradient(to right, #fcc477, #d47b02);
          box-shadow: 0 10px 14px rgba($color: #d47b02, $alpha: 0.5);
          border-radius: 60px;
          margin-bottom: 15px;
          cursor: pointer;
          font-weight: bold;
        }
        em{
          font-size: 36px;
          color: #d47b02;
        }
      }
    }
  }
  .mod2{
    .mod-con{
      img{
        display: block;
        margin: 0 auto 55px;
      }
      .item{
        border: 4px solid #feebd0;
        padding: 20px 30px 20px 20px;
        overflow: hidden;
        border-radius: 10px;
        +.item{
          margin-top: 22px;
        }
        p{
          font-size: 36px;
          color: #d47b02;
          float: left;
          margin-top: 13px;
          font-weight: bold;
          &.spe{
            line-height: 55px;
            em{
              color: #e02f3a;
            }
          }

        }
        span{
          float: right;
          font-size: 34px;
          color: #fff;
          display: block;
          width: 280px;
          height: 80px;
          text-align: center;
          background: linear-gradient(to right, #fcc477, #d47b02);
          box-shadow: 0 10px 14px rgba($color: #d47b02, $alpha: 0.5);
          border-radius: 60px;
          cursor: pointer;
          font-weight: bold;
          letter-spacing: 2px;
          padding-top: 3px;
          &.spe{
            line-height: 80px;
            padding-top: 0;
          }
          &.spe2{
            margin-top: 20px;
          }
          em{
            font-size: 18px;
            display: block;
          }
        }
      }
      .banner-wrap{
        padding-left: 5px;
        padding-right: 5px;
      }
      >p{
        font-size: 16px;
        color: #d47b02;
        margin-top: 15px;
      }
    }
  }
  .tips{
    color: #fff;
    font-size: 16px;
    text-align: center;
    padding: 76px 0;
    opacity: 0.4;
  }
  .mod3{
    .mod-con{
      .item{
        +.item{
          margin-top: 45px;
        }
        &:nth-child(2) {
          p{
            margin-top: 30px;
          }
        }
        &:nth-child(3) {
          p{
            margin-top: 50px;
          }
        }
        &:nth-child(4) {
          p{
            margin-top: 55px;
          }
        }
         img{
            float: left;
            margin-bottom: 0;
          }
        p{
          width: 700px;
          float: right;
          font-size: 34px;
          line-height: 55px;
          text-align: justify;
          em{
            color: #e02f3a;
          }
        }
      }
    }
  }
  /deep/
  .el-carousel__arrow{
    background: rgba($color: #b51219, $alpha: 0.5);
    width: 93px;
    height: 93px;
    i{
      font-size: 55px;
    }
  }
  /deep/
  .el-carousel__arrow--left{
    left: 0px;
  }
  /deep/
  .el-carousel__item img{
    width: 800px;
    height: 600px;
  }
  /deep/
  .el-carousel{
    width: 1028px;
    height: 600px;
  }
  /deep/
  .el-carousel__arrow--right{
    right: 0;
  }
  .time2{
    background: #fdf3bb;
    border-radius: 50px;
    font-size: 50px;
    color: #b51219;
    width: 755px;
    height: 94px;
    line-height: 94px;
    text-align: center;
    margin: 60px auto 0px;
    padding-left: 12px;
    box-shadow: 0 5px #6d0004;
    em{
      color: #fdf3bb;
      padding: 12px 50px 12px 20px;
      border-radius: 0 40px 40px 0;
      background: #b51219;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202111.vue